import { FaPhoneAlt } from "react-icons/fa";
const ModalHeader = ({ participant, callNumber, formatOrdinal }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, paddingBottom: 8 }}>
      <div style={{
        background: '#1890ff',
        borderRadius: '50%',
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <FaPhoneAlt style={{ fontSize: 20, color: "white" }} />
      </div>
      <div>
        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1890ff' }}>
          {formatOrdinal(callNumber)} Llamada - Registro
        </div>
        <div style={{ fontSize: '14px', color: '#666' }}>
          {participant.nombres} {participant.apellidos} • {participant.num_identificacion}
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;